import React, { useEffect, useState } from "react";
import SummaryApi from "../../../common";

const SubAccountManager = () => {
  const [subAccounts, setSubAccounts] = useState([]);
  const [editingMobile, setEditingMobile] = useState(null);
  const [userName, setUserName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    mobile: "",
    role: "CANDIDATE",
    pad: "",
    accessKey: "",
  });

  const user = JSON.parse(localStorage.getItem("umedwarUser"));

  useEffect(() => {
    if (user) {
      setUserName(user.fullName);
    }
  }, [user]);

  // 🟢 Fetch sub accounts
  const fetchSubAccounts = async () => {
    if (!user) return;
    try {
      setLoading(true);
      const res = await fetch(`${SummaryApi.GetSubUmedwar.url}/${user.mobile}`);
      const data = await res.json();
      setSubAccounts(data || []);
    } catch (err) {
      console.error("Error fetching sub accounts:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubAccounts();
  }, []);

  // 🟢 Handle form submit (Create or Update)
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const url = editingMobile
        ? `${SummaryApi.UpdateSubUmedwar.url}/${editingMobile}`
        : SummaryApi.CreatedSubUmedwar.url;

      const method = editingMobile ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          parentMobile: user.mobile,
          allowedColumns: user.allowedColumns || [],
        }),
      });

      const result = await res.json();

      if (res.ok) {
        alert(editingMobile ? "Sub account updated!" : "Sub account created!");
        setShowModal(false);
        setEditingMobile(null);
        resetForm();
        fetchSubAccounts();
      } else {
        alert(result.message || "Operation failed");
      }
    } catch (err) {
      console.error("Error:", err);
      alert("Something went wrong!");
    }
  };

  // 🧹 Reset form fields
  const resetForm = () => {
    setFormData({
      fullName: "",
      mobile: "",
      role: "CANDIDATE",
      pad: "",
      accessKey: "",
    });
  };

  // ✏️ Handle Edit
  const handleEdit = (acc) => {
    setFormData({
      fullName: acc.fullName,
      mobile: acc.mobile,
      role: acc.role,
      pad: acc.pad,
      accessKey: acc.accessKey,
    });
    setEditingMobile(acc._id);
    setShowModal(true);
  };

  // 🗑️ Handle Delete
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this sub account?"))
      return;
    try {
      const res = await fetch(`${SummaryApi.DeleteSubUmedwar.url}/${id}`, {
        method: "DELETE",
      });
      const result = await res.json();
      if (res.ok) {
        alert("Deleted successfully!");
        fetchSubAccounts();
      } else {
        alert(result.message || "Delete failed");
      }
    } catch (err) {
      console.error("Error deleting sub account:", err);
    }
  };

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">
          Manage Sub Accounts
        </h1>
        <button
          onClick={() => {
            resetForm();
            setEditingMobile(null);
            setShowModal(true);
          }}
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg shadow-md"
        >
          + Create Sub Account
        </button>
      </div>

      {/* Summary */}
      <div className="mb-4 text-lg font-semibold text-gray-700">
        Total Sub Accounts:{" "}
        <span className="text-blue-600">{subAccounts.length}</span>
      </div>

      {/* Table */}
      <div className="overflow-x-auto bg-white shadow-md rounded-xl">
        <table className="min-w-full border border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 border">Name</th>
              <th className="px-4 py-2 border">Mobile</th>
              <th className="px-4 py-2 border">Role</th>
              <th className="px-4 py-2 border">Pad</th>
              <th className="px-4 py-2 border">Created</th>
              <th className="px-4 py-2 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  Loading...
                </td>
              </tr>
            ) : subAccounts.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-4 text-gray-500">
                  No sub accounts found.
                </td>
              </tr>
            ) : (
              subAccounts.map((acc, i) => (
                <tr key={acc._id || i} className="text-center hover:bg-gray-50">
                  <td className="border px-4 py-2">{acc.fullName}</td>
                  <td className="border px-4 py-2">{acc.mobile}</td>
                  <td className="border px-4 py-2">{acc.role}</td>
                  <td className="border px-4 py-2">{acc.pad}</td>
                  <td className="border px-4 py-2">
                    {new Date(acc.createdAt).toLocaleDateString()}
                  </td>
                  <td className="border px-4 py-2 flex justify-center gap-2">
                    <button
                      onClick={() => handleEdit(acc)} // ✅ fixed
                      className="px-3 py-1 bg-yellow-500 text-white rounded hover:bg-yellow-600"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(acc._id)} // ✅ fixed
                      className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-2xl shadow-lg w-[90%] md:w-[400px]">
            <h2 className="text-xl font-bold mb-4 text-gray-800">
              {editingMobile ? "Edit Sub Account" : "Create Sub Account"}
            </h2>
            <form onSubmit={handleSubmit} className="flex flex-col gap-3">
              <input
                type="text"
                placeholder="Full Name"
                value={formData.fullName}
                onChange={(e) =>
                  setFormData({ ...formData, fullName: e.target.value })
                }
                className="border p-2 rounded"
                required
              />
              <input
                type="text"
                placeholder="Mobile Number"
                value={formData.mobile}
                onChange={(e) =>
                  setFormData({ ...formData, mobile: e.target.value })
                }
                className="border p-2 rounded"
                required
                disabled={!!editingMobile} // prevent editing mobile on update
              />
              <input
                type="text"
                placeholder="Pad (Position)"
                value={formData.pad}
                onChange={(e) =>
                  setFormData({ ...formData, pad: e.target.value })
                }
                className="border p-2 rounded"
                required
              />
              <input
                type="text"
                placeholder="Access Key"
                value={formData.accessKey}
                onChange={(e) =>
                  setFormData({ ...formData, accessKey: e.target.value })
                }
                className="border p-2 rounded"
                required
              />
              <select
                value={formData.role}
                onChange={(e) =>
                  setFormData({ ...formData, role: e.target.value })
                }
                className="border p-2 rounded"
              >
                <option value="CANDIDATE">CANDIDATE</option>
                <option value="SUPERVISOR">SUPERVISOR</option>
                <option value="WARD_MEMBER">WARD MEMBER</option>
                 <option value="BOOTH_PRAMUKH">BOOTH_PRAMUKH</option>
              </select>

              <div className="flex justify-end gap-3 mt-3">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 bg-gray-300 rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  {editingMobile ? "Update" : "Create"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubAccountManager;
